<template>
  <div>
    <SelectBlock v-if='!blocks.length'
      class='p-2'
      v-bind="$props"
      key='select'

      @add-block="addBlock"
    >
        <div class="add-new-block d-flex align-items-center justify-content-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clip-rule="evenodd" />
          </svg>
          <h3>Add new block</h3>
        </div>
    </SelectBlock>
    <div v-else key='content'>
      <div class="blocks-content" ref='content'>
        <div v-for="item in blocks"
          class="block drag-handle d-flex justify-content-between"
          :key="item.id"
          :data-id='item.id'
        >
          {{ item.title }}

          <span
            class="delete-icon"
            @click.prevent.stop="deleteBlock(item.id)"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </span>
        </div>
      </div>
      
      <div v-if='!singleBlock' class="d-flex ignore-element">
        <SelectBlock v-bind="$props" @add-block="addBlock" :align-to-left='true'>
          <button class="d-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width='14' height='14' viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clip-rule="evenodd" />
            </svg>
            <span class='ml-2'>Add new block</span>
          </button>
        </SelectBlock>
      </div>
    </div>
  </div>
</template>

<script>

import SelectBlock from "./Components/SelectBlock.vue"

import Sortable from "sortablejs"

export default {
  props: {
    config: Object,
    fullDomainLink: String,
    singleBlock: Boolean,
    position: String,
    currentClientWidth: Number,
  },
  components: {
    SelectBlock,
  },
  created() {
    const config = this.config
    if (config && !this.singleBlock) {
      this.blocks = config.blocks
    } else if (config[this.position]) {
      this.blocks = [config[this.position]]
    }
  },
  beforeDestroy() {
    this.destroy()
  },
  data() {
    return {
      blocks: [],
    }
  },
  methods: {
    addBlock(block) {
      if (this.blocks.some(item => item.id === block.id)) return;
      this.blocks.push(block)
    },
    deleteBlock(id) {
      this.blocks.splice(this.blocks.findIndex(block => block.id === id), 1)
    },
    destroy() {
      this.instance && this.instance.destroy()
    },
    mount() {
      this.destroy()
      this.instance = new Sortable(this.$refs.content, {
        handle: ".drag-handle",
        draggable: ".block",
        sort: true,
        filter: ".ignore-element",

        forceFallback: true,
        fallbackOnBody: true,
        direction: "horizontal",

        onUpdate: () => {
          this.$nextTick(() => {
            const ids = [...this.$refs.content.children].map(el => el.dataset.id)
            this.blocks = ids.map(id => this.blocks.find(block => block.id === id))
          })
        },
      })
    },
  },  
  watch: {
    blocks(val) {
      this.$emit('set-blocks', val.map(block => ({ title: block.title, id: block.id })))

      if (val.length) {
        this.$nextTick(() => this.mount())
      } else {
        this.destroy()
      }
    },
  },
}

</script>

<style scoped>

.delete-icon {
  color: rgb(180, 180, 180);
  transition-duration: 0.15s;
}

.delete-icon:hover {
  color: var(--red);
}

.block {
  font-size: 18px;
  font-weight: 600;
  padding: 14px 8px;
  cursor: pointer;
}

.block:hover {
  background-color: rgb(252,252,252);
}

.block + .block {
  border-top: 1px solid rgb(242,242,242);
}

.blocks-content {
  margin: 12px 0;
}

button {
  border-radius: 6px;
  font-weight: 500;
  padding: 8px 12px;
  color: var(--primary);
  border: 1px solid rgb(228,228,228);
}

button:hover {
  background-color: rgb(251,251,251);
}

.add-new-block {
  border: 1px solid rgb(200,200,200);
  border-style: dashed;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  min-height: 100px;
  cursor: pointer;
  transition-duration: .15s;
}

.add-new-block:hover {
  background-color: rgb(248,248,248);
}

.add-new-block h3 {
  margin-left: 8px;
}

h3 {
  margin: 0;
  font-weight: 500;
}

</style>
